export { default as ContactsPage } from './ContactsPage';
export { default as ContactPage } from './ContactPage';



// WEBPACK FOOTER //
// ./src/contacts/index.js